/* AlohaClothes homepage motion (2026-11-02): scroll reveals + lazy silent video loops. No motion for prefers-reduced-motion; no video on data saver. */
(function(){
  if (window.__ahMotion) return; window.__ahMotion = 1;
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var c = navigator.connection, save = !!(c && (c.saveData || /2g/.test(c.effectiveType || '')));
  var desk = window.matchMedia('(min-width: 900px)');
  function run(){
    var d = document, hasIO = 'IntersectionObserver' in window;
    if (!rm && hasIO) {
      var sel = '[data-ah-reveal], .template-index carousel-brands .carousel__title';
      var vh = window.innerHeight || 800, list = [];
      d.querySelectorAll(sel).forEach(function(el){
        if (el.getBoundingClientRect().top > vh * 0.98) { el.classList.add('ah-rv'); list.push(el); }
      });
      d.documentElement.classList.add('ah-motion');
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -2% 0px', threshold: 0.01 });
      list.forEach(function(el){ io.observe(el); });
      window.addEventListener('beforeprint', function(){ list.forEach(function(el){ el.classList.add('is-in'); }); });
    }
    if (rm || save || !hasIO) return;
    var vio = new IntersectionObserver(function(es){
      es.forEach(function(e){
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.getAttribute('src')) {
            v.src = desk.matches ? v.dataset.d : v.dataset.m;
            v.addEventListener('playing', function(){ v.classList.add('is-on'); }, { once: true });
          }
          var p = v.play(); if (p && p.catch) p.catch(function(){});
        } else if (v.getAttribute('src')) { v.pause(); }
      });
    }, { rootMargin: '200px 0px' });
    d.querySelectorAll('video.ah-vid').forEach(function(v){ vio.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
